<div class="content">
  <div class="step-container">
    <div class="step-title">
      <div>
        <span class="step-title-number">{{ stepDisplayNumber }}</span>
        <span class="step-title-text">{{ translateString | translate }}</span>
        <a *ngIf="!readOnly" class="step-edit" (click)="gotoStep()" href="javascript:void(0)">
          {{ 'SUMMARY.EDIT' | translate }}
        </a>
      </div>
      <div class="step-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
